/** The six code boxes of a one-time-password field, spread across the card's width. */
export const OTP_CONTAINER_CLASS = 'justify-between';

export const OTP_INPUT_CLASS =
    'border-grey-300 focus:border-primary focus:shadow-focus-ring m-2 w-full rounded-[4px] border p-2.5 text-center focus:outline-none';
